module.exports = __webpack_public_path__ + "static/img/example-4.091880c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-4.png
// module id = jmEC
// module chunks = 2